export default "__VITE_ASSET__4faf22de__"